import styled, { css } from 'styled-components';

export const Input = styled.input`
  font-family: 'Nunito Sans', sans-serif;
  width: 100%;
  box-sizing: border-box;
  height: auto;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
  padding: 6px 4px;
  border-radius: 8px;
  border: none;
  box-shadow: none !important;

  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.semantic.text.primary};

  &:disabled {
    background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
    opacity: 50%;
  }

  :focus,
  &:focus-within,
  :focus-visible {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: color 0.15s ease-in-out 0s;
    -webkit-text-fill-color: ${({ theme }) =>
      theme.colors.semantic.text.primary};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: inherit;
`;

const inputGroupBorderModifier = ({ theme }) => ({
  withBorder: `1px solid ${theme.colors.semantic.action.primary}`,
  withoutBorder: 'none',
});

export const InputGroup = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  border-radius: 8px;
  overflow: hidden;
  height: 24px;
  width: 100%;
  transition: border 0.15s ease-in-out 0s;
  outline: none;
  background-color: ${({ theme, editInlineMode }) =>
    editInlineMode ? theme.colors.semantic.surface.card : 'transparent'};
  cursor: text;

  ${({ theme, editInlineMode }) => css`
      svg {
        color: ${theme.colors.semantic.text.secondary};
      }

      &:hover {
        background-color: ${theme.colors.semantic.surface.muted};
        transition: background-color 0.15s ease-in-out 0s,
          color 0.15s ease-in-out 0s;

        span {
          color: ${theme.colors.semantic.text.primary};
        }

        svg {
          color: ${theme.colors.semantic.text.primary};
        }
      }

      border: ${
        editInlineMode
          ? inputGroupBorderModifier({ theme }).withBorder
          : inputGroupBorderModifier({ theme }).withoutBorder
      };
    }
  `}
`;

export const InputValue = styled.p`
  font-family: inherit;
  display: inline-block;
  height: 100%;
  width: fit-content;

  margin: 0;
  padding: 0;

  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  background-color: inherit;
  color: ${({ theme }) => theme.colors.semantic.text.primary};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;

  svg {
    height: 16px;
    width: auto;
  }
`;

export const InputIcon = styled.span`
  display: flex;
  align-items: center;
  padding: 8px 0;
  height: 100%;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};

  svg {
    height: 16px;
    width: auto;
  }
`;
